"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  chr: {
    roleName: 'Role Name',
    officeCode: 'Office Code',
    leaseDate: 'Lease date',
    leaseTermLength: 'Lease term length',
    rfRate: 'Rent/freight rate',
    commissionRate: 'commission rate',
    dlDate: 'Delivery date/loading period',
    returnTime: 'time for return of a ship',
    actDelTime: 'Delivery date',
    actRedTime: 'Repayment schedule',
    broker: 'broker',
    isObo: 'Are the terms is obo? If not, please provide further explanation',
    depReq: 'Requirements for issuance of the departure certificate',
    otherRemark: 'Other handover matters',
    planeVoyageStatus: 'The initiated voyage cannot be deleted',
    cargoDesc: 'Cargo Desc',
    addPort: 'Add Port',
    homeCurrency: 'homeCurrency',
    hasContractInfoError: 'The existence of operating companies with contract information is inconsistent with the calculation',
    currentTitle: 'When the promissory note pattern',
    rollTitle: 'Rolling billing mode',
    titlePlane: 'Voyage planning information',
    toArapMessage: 'The status of receivables and payables is yes and cannot be abolished',
    messageStatus: 'The estimates were not audited and the voyage plan could not be generated',
    messAlready: 'The voyage has already been planned',
    InitiatingVoyage: 'Initiating voyage',
    voyageGusuan: 'Voyage estimate',
    messageVoyage: 'Only one piece of data can be selected. Please select another one',
    addVoyagePlan: 'Generate a voyage plan',
    specialFouceCargo: 'Are there any oversized/heavy items that exceed the crane lifting capacity',
    shipCraneDis: ' Will crane operations be conducted',
    useAgent: 'Do you have any recommended agents',
    speedRequest: 'speed requirement',
    charterAgent: 'Will we rent a designated agent recommended by the company? If not, please recommend an agent',
    grabBucket: 'Will a grab bucket be used on board',
    portConditions: 'Has the port been inquired about in advance for the business',
    stateroomRequest: 'stateroom request',
    fuelConsumption: 'Requirements for sailing speed and fuel consumption ',
    voyageIntention: 'Intention of voyage',
    ballastDirection: 'direction of empty container',
    needAgent: 'Will shipowner protective agency be arranged',
    pniGaugingInspectio: 'Verify if the loading and unloading ports have hired PNI draft surveyors for inspection',
    specialTermsCharter: 'additional promised or declined special requests from tenants',
    urgentDispatch: 'Urgent matters after the contract is signed',
    specialCabinArrangements: 'Cabin allocation requirements, special cabin arrangements',
    brokerContact: 'Broker/charter contact information',
    oilPlan: 'refueling plan',
    oilPlanCopy: ' we have a refueling plan for our company',
    noBL: 'there any release of cargo without a single document',
    voyageHandover: 'Voyage handover',
    absrtact: 'Abstract',
    signatureTime: 'Date of signature',
    vesselNameOne: 'Ship',
    contractList: 'Contract list',
    portDisbursementSource: 'Port Disbursement Source',
    otherFee: 'Other Fee',
    supervisionFee: 'Supervision Fee',
    eindingFee: 'Binding Fee',
    loadDischargeFee: 'Load Discharge Fee',
    portDisbursement: 'Port Disbursement',
    cargoManagementDays: 'Cargo Management Days',
    tankWashDays: 'Tank Wash Days',
    berthDays: 'Berth Days',
    dischargeDay: 'Discharge Day',
    loadDay: 'Load Day',
    lsDistance: 'LS Distance',
    distance: 'Distance',
    portName: 'Port Name',
    portPurpose: 'Port Purpose',
    planePortList: 'Port list',
    createrUser: 'Founder',
    manageCompany: 'Manage Company',
    addRepair: 'New repair sailings',
    addNewAir: 'New air voyages added',
    document: 'document',
    operateBy: 'operate By',
    voyageCurrency: 'Voyage Currency',
    estEndDate: 'Est End Date',
    estBeginDate: 'Est Begin Date',
    vesselSource: 'Vessel Source',
    fuelPricing: 'Fuel Pricing',
    additionalOperationDay: 'Additional Operation Day',
    additionalSailingDay: 'Additional Sailing Day',
    vesselStability: 'Vessel Stability',
    vesselDisplacement: 'Vessel Displacement',
    totalProfit: 'Total Profit',
    dailyProfitLevel: 'Daily Profit Level',
    totalCost: 'Total Cost',
    heavyLoadSpeed: 'Heavy load speed',
    sailingSpee: 'Sailing Spee',
    opeRateDays: 'OpeRate Days',
    sailingDay: 'Sailing Day',
    association: 'Association',
    lastPort: 'Last Port',
    firstPort: 'First Port',
    checkStatus: 'Check Status',
    operationManagement: 'Operation management',
    shipManagementContract: 'Ship management contract',
    escrowContract: 'Escrow contract',
    escrowContractManager: 'Escrow contract manager ',
    contractInfo: 'Contract information',
    contNo: 'Contract No',
    contType: 'contType',
    contStatus: 'contStatus',
    contractName: 'Contract name',
    contractDate: 'Contract Date',
    contractTime: 'Contract Time',
    endDate: 'End Date',
    effectDate: 'Effective date',
    shipTeam: 'Ship Team',
    effectDescription: 'Effective description',
    modelContract: 'Model contract',
    contractCurrency: 'Contract currency',
    isMajorContract: 'Major contract or not',
    handledBy: 'Handled by',
    lastUpdatedBy: 'Last update by',
    handlingTime: 'Handling time',
    updateTime: 'Update time',
    shipInfo: 'Ship information',
    shipName: 'Ship name',
    voyageNo: 'Voyage No',
    cargoInSummer: 'DWT of cargo in summer',
    fullLoadDraft: 'Full load draft',
    shipDescription: 'Ship description',
    ourContractInfo: 'Our contracting information',
    signatorySub: 'Signatory subject',
    signatory: 'Signatory',
    hasProvideContract: 'Whether to provide guarantee for the contract',
    shipOwner: 'Ship owner',
    propCompany: 'Proprietary company',
    MgtFeeAndTime: 'Management fee and time',
    otherProvisions: 'Other provisions',
    contractAnnex: 'Contract annex',
    contractForm: 'Contract Approval Form',
    contractFiling: 'Contract filing',
    updAtt: 'Upload attachments',
    check: 'check',
    attName: 'Attachment name',
    uploadTime: 'Upload time',
    uploader: 'uploader',
    uploadDep: 'Upload Department',
    historyAppComments: 'Historical approval comments',
    appPhase: 'Approval phase',
    appTime: 'Approval time',
    approver: 'Approver',
    corporateName: 'Corporate name',
    appDep: 'Approval department',
    appAction: 'Approval action',
    appComments: 'Approval comments',
    agree: 'agree',
    reject: 'reject',
    action: 'action',
    nowApprover: 'Now Approver',
    nowAppDep: 'Now Approval department',
    handingOption: 'Handing options',
    appProcess: 'Approval process',
    isSendLegalSystem: 'Whether to send legal system',
    contFilingDate: 'Contract filing date',
    contArchiver: 'Contract Archiver',
    contNumber: 'Total number of contracts',
    contFilingDep: 'Contract filing department',
    contFilingNumber: 'Number of contracts filed',
    otherDep: 'Other original holding departments',
    heldNumber: 'Number of shares held',
    remark: 'remark',
    tips: 'Tips:\n' + '1. Only when the contract review status is Approved can the contract be archived;\n' + '\n' + '2. After the contract is archived and confirmed, all contract information will be locked and cannot be adjusted.',
    // 提单管理
    BillMgmt: 'Bill of Lading Management',
    searchFilter: 'search voyageNo And blNo',
    searchFilterNo: 'search contractNo And blNo',
    searchFilterTwo: 'search voyageNo And soNo',
    searchFilterThree: 'search voyageNo And blNo And soNo',
    BLTracking: 'Bill of Lading Tracking',
    BLTemplate: 'Bill of Lading Template Management',
    BLTemplateEdit: 'Bill of Lading Template Editor',
    vesselName: 'Vessel Name',
    // voyageNo: 'Voyage no',
    carrierName: 'Carrier name',
    sendAgentFlag: 'Whether the agent has been sent',
    creator: 'Created by',
    createTime: 'createTime',
    createTimeFrom: 'createTimeFrom',
    createTimeTo: 'createTimeTo',
    vesselCode: 'Vessel code',
    vesselEnName: 'Vessel English Name',
    vesselCnName: 'Vessel Chinese Name',
    ripCode: 'Related party code',
    nameCn: 'Chinese name',
    nameEn: 'English name',
    sendProxy: 'Send proxy',
    BLList: 'Bill of Lading List',
    CMRList: 'Chief Mate Receipt List',
    mainInformation: 'Main information',
    basicInformation: 'Basic information',
    sendAgentDate: 'Send agent date',
    signature: 'signature',
    lastModifyBy: 'Last modify by',
    lastModifyTime: 'Last modify time',
    polInformation: 'POL information',
    podInformation: 'POD information',
    soNo: 'Chief Mate Receipt No',
    polName: 'port of loading',
    podName: 'Port of discharge',
    issuePlace: 'Issue place',
    contractNo: 'Contract no',
    chartererName: 'Charterer name',
    chartererName1: 'Charterer name',
    checkContract: 'Check contract',
    shippingAgentName: 'Shipping agent name',
    shippingAgentMail: 'Shipping agent mail',
    email: 'email',
    ladMessage: 'Bill of Lading Information',
    copyAdd: 'Copy added',
    copyNewAdd: 'Copy new first mate receipt',
    look: 'To view',
    lodNo: 'Bill of lading No.',
    code: 'Associated mate receipt number',
    twoInfo: ' Mate receipt information',
    daCode: 'Mate receipt number',
    copyLod: 'Copy the new bill of lading',
    relactNo: 'Associated Bill of Lading number',
    forwarder: 'Freight forwarder interface',
    templateSearch: 'Bill of Lading template query',
    issueType: 'Telex release/original',
    blFormat: 'Bill of Lading Format',
    sure: 'confirm',
    cancel: 'cancel',
    templateDetail: 'Bill of lading details editing',
    submit: 'submit',
    upload: 'The letter of guarantee has been signed and uploaded',
    newUpload: 'The bill of lading has been signed and uploaded',
    placeholderlodNo: 'Bill of lading number prefix',
    shipperDesc: 'Consignor',
    consigneeDesc: 'Consignee of goods',
    notifyDesc: 'Person of notice',
    marks: 'Marks',
    noOfPackage: 'number',
    grossWeight: 'Weight',
    goodsCube: 'volume',
    goodsDesc: 'Description of',
    preloadingDesc: 'Pre-assembly inspection notation',
    deckDesc: 'Deck cargo notation',
    totalDesc: 'Number of pieces Description in English',
    issueDate: 'Time of issue',
    noOfOriginalBl: 'Number of original bill of lading',
    otherInfo: 'Other Information',
    approvalStatus: 'Status of audit',
    approvalStatus2: 'Status of audit',
    invalidFlag: 'Status of audit',
    releaseFlag: 'Order release status',
    releaseTime: 'Order release time',
    retakeFlag: 'Order release time',
    retakeTime2: 'Bl Recovery time',
    retakeTime: 'Recovery time',
    associateone: 'Associate the mate receipt',
    infomation: 'Attachment Information',
    messageNumber: 'Mate receipt number',
    errorMessage: 'Please try again',
    errorBlno: 'The bill of lading number already exists and cannot be saved',
    message: 'If the word "order" appears in the column of consignee, shall we continue to save it?',
    grossWeightValid: 'The gross weights are not consistent',
    goodsCubeValid: 'The volume is not consistent',
    noOfPackageValid: 'The number of entries is inconsistent',
    descError: 'Current Bill of lading is inconsistent with [field label name] of [Mate Receipt Number]. Do you want to keep it?',
    timeError: 'The date of issue of the current bill of lading is not consistent with the shipping date of [Mate Receipt Number]. Shall we keep it?',
    loadDateCheckMsg: 'The date of issue of the current bill of lading is not consistent with the shipping date of Mate Receipt [ {soNo}]. Shall we keep it?',
    descCheckMsg: 'Current Bill of lading is inconsistent with [{desc}] of Mate Receipt[{soNo]. Do you want to keep it?',
    keepIt: 'Do you want to keep it?',
    // 大副收据管理
    mateManagement: 'Chief Mate Receipt Management',
    state: 'state',
    mateDetailedEdit: 'Chief Mate Receipt Details Editing',
    // 提单管理
    loiConfirmFlag: 'Letter of guarantee or not',
    errorApprovalStatus: 'The approval status of the bill of lading is',
    noDelete: 'Cannot be deleted',
    putSingle: 'Put a single',
    exportManifest: 'Export manifest',
    exportManifestCheck: 'The filtering conditions for vessel, voyage, loading port, and unloading port have not been entered and cannot be exported.',
    recall: 'Bill of lading recall',
    process: 'Approval Process',
    relaceblSo: 'Associate the mate receipt',
    relactContract: 'Associated Contract Number',
    isRelease: 'Whether to release the order',
    releaseMessage: 'Please fill in the release event',
    exportCheck: 'No approved bill of lading data found Unable to export manifest',
    submitApproval: 'Submit for approval',
    cancelApproval: 'Cancel for approval',
    approval: 'Approval',
    viewFlow: 'View flow',
    rejerction: 'Rejection of freight forwarding',
    send: 'Sending an Email',
    blAddDialog: 'Designated bill of lading format/loading and unloading port',
    soAddDialog: 'Designated loading and unloading port',
    guarantee: 'Generation of guarantee',
    sureGuarantee: 'Letter of confirmation',
    cancelSureGuarantee: 'Cancel Letter of confirmation',
    invalid: 'invalid',
    risk: 'Screening for risk',
    warningTidan: 'Please save the data first',
    templadeError: 'Check bill of lading is not the same ship name voyage, cannot operate',
    messageError1: 'Select the organization you want to operate',
    messageError2: 'The bill of lading number has been associated with the mate receipt, so it cannot be operated',
    hcbCode: 'hbc Code',
    // 正本提单回收
    time: 'time',
    shipType: 'Ship type',
    original: 'The original bill of lading is released',
    voyage: 'Number of voyage',
    goodsGuarantee: 'Release the goods by guarantee',
    originalWithdrawn: 'All original bill of lading withdrawn',
    originalNoWithdrawn: 'The original bill of lading is not recalled in full',
    tian: 'Number of days',
    cargoGroup: 'CargoGroup',
    voyageType: 'voyageType',
    voyageEndTime1: 'End time of voyage',
    voyageStartTime1: 'Voyage start time',
    voyageEndTimeFr: 'End time of voyage from:',
    voyageEndTimeTo: 'The end of the voyage is up:',
    portCode: 'Port Code',
    //航次测算
    voyageEstimate: 'Voyage estimate',
    voyageEstimateQuery: 'Voyage estimate query',
    newTimeLeaseBulkCargo: 'New time lease bulk cargo',
    newRentBulkCargo: 'New rent bulk cargo',
    newTransferCharter: 'New Transfer charter',
    createContract: 'Create contract',
    quickCalculation: 'Quick calculation',
    portfolioCalculation: 'Portfolio calculation',
    fleet: 'Fleet',
    voyageSeq: 'Voyage NO',
    isHistory: 'Settlement version',
    vesselType: 'Ship Type',
    estimateNo: 'Estimate NO',
    estimateType: 'Estimate Type',
    estimateDate: 'Estimate Date',
    estimator: 'Estimator',
    relationCp: 'Relation CP',
    hireCost: 'Hire Cost',
    freightRate: 'Freight Rate',
    freightTotalIncome: 'Freight total income',
    freightTotalExpense: 'Freight total expense',
    profit: 'Profit',
    averageDailyProfit: 'Average daily profit',
    item: 'item',
    actualDays: 'Actual days',
    roundDays: 'Round days',
    roundAmount: 'ROUND Amount',
    rentBulkCargoDetail: 'Rent bulk cargo detail',
    timeLeaseCargoDetail: 'Time lease cargo detail',
    measuredShipInfomation: 'Measured ship information',
    palletInformation: 'Pallet information',
    timeLeaseRentInformation: 'Time lease rent information',
    ballastInformation: 'Air release information',
    hangingInformation: 'Hanging information',
    ballastVoyageTimeConsume: 'Ballast voyage time consume',
    ballastVoyageFuelConsume: 'Ballast voyage fuel consume',
    voyageTimeConsumption: 'Voyage time consumption',
    beginTime: 'Begin time',
    endTime: 'End time',
    voyageFuelConsumption: 'Voyage fuel consumption',
    energyEfficiencyInformation: 'Energy information',
    calculationResult: 'Calculation result',
    otherExpense: 'Other expense',
    leaseInRent: 'Lease in rent',
    vessel: 'Vessel',
    vesselFrom: 'Vessel from',
    voyageStartTime: 'Voyage start time',
    voyageEndTime: 'Voyage end time',
    currency: 'Currency',
    addFromPallet: 'Add from pallet',
    cargoType: 'Cargo Type',
    palletName: 'Pallet name',
    cargoName: 'Cargo name',
    billVolume: 'Bill volume',
    quantityUnit: 'Quantity Unit',
    unitPrice: 'Unit price',
    freight: 'Freight',
    dailyHire: 'Daily hire',
    addComm: 'Add Comm',
    totalAddComm: 'Total add comm',
    brokerage: 'Brokerage',
    palletNo: 'Pallet no',
    idlerDays: 'Ballast days',
    ladenSeaDays: 'Laden sea days',
    loadDays: 'Load days',
    dischargeDays: 'Discharge days',
    portNotWorkDays: 'Waiting',
    acrossTheCanal: 'Across the canal',
    exportCurrentPage: 'Export current page',
    insertRow: 'Insert row',
    portChange: 'Port change',
    acquirePortSpace: 'Acquire port space',
    voyageTceNet: 'TCE',
    dayTecNet: 'Daily TCE',
    dayVoyageProfit: 'Daily profit',
    totalFreightIncome: 'Total freight income',
    totalRentalIncome: 'Total rental income',
    totalRental: 'Total rental',
    BBIncome: 'BB Income',
    BBCost: 'BB Cost',
    surcharge: 'Surcharge',
    demurrageCharge: 'Demurrage charge',
    otherIncome: 'Other income',
    totalIncome: 'Total income',
    totalCommission: 'Total commission',
    netIncome: 'Net income',
    expenditures: 'Total port cost',
    fuelExpense: 'Total bunker expense ',
    ballastFuelExpense: 'Ballast Fuel Expense',
    dayRentCost: 'Daily rent/cost',
    ohterFeeExpense: 'Other expense',
    totalExpense: 'Total expense',
    totalCarbonEmissions: 'Total carbon emissions',
    currentValue: 'Current value',
    carbonEmissionCurrent: 'Annual accum',
    carbonEmissionCumulative: 'Voyage accum',
    ciiRank: 'CII Voyage',
    ciiRankEst: 'CII',
    ciiLevel: 'CII Level',
    accumValue: 'Accum value',
    voyageEmissions: 'Voyage emissions',
    estimateValue: 'Estimate value',
    expenseAndReceipts: 'Expense and receipts',
    expenseType: 'Expense type',
    expenseAmount: 'Expense amount',
    hireDay: 'Hire day',
    hire: 'Hire',
    destination: 'PPS',
    portDistance: 'Distance',
    lowSulfurArea: 'SECA',
    isLowSulfurArea: 'In SECA',
    seaMargin: 'Sea Margin',
    seaDays: 'Sailing',
    lowSulfurAreaDay: 'SECA day',
    portExpense: 'Port Disbursment',
    breakevenCost: 'Breakveen cost',
    breakevenFee: 'Breakeven fee',
    breakevenDays: 'Breakeven days',
    ballastSpeed: 'Item(Speed)',
    dailyFuelConsumption: 'Daily averge speed oil cost',
    emptyVoyage: 'Empty Voyage',
    fullVoyage: 'Full Voyage',
    noOperatorPort: 'No Operator Port',
    unloadOperatorPort: 'Unload Operator Port',
    loadOperatorPort: 'Load Operator Port',
    shipUnLoadOperatorPort: 'Ship Unload Operator Port',
    shipLoadOperatorPort: 'Ship Load Operator Port',
    actualFuelConsumption: 'Subtotal of fuel',
    roundFuelConsumption: 'Round fuel consumption',
    HSFO: 'HSFO',
    LSFO: 'LSFO',
    HSMGO: 'HSMGO',
    LSMGO: 'LSMGO',
    ballastDays: 'Ballast days',
    rentDays: 'Rent days',
    voyageDays: 'Voyage days',
    workDays: 'Work days',
    lodDisFee: 'Lod Dis Fee',
    liftingFee: 'Lifting Fee',
    bindingFee: 'Binding Fee',
    rulingFee: 'Ruling Fee',
    isShipCarne: 'Is Ship Carne',
    hireMessage: 'Please insert time lease rent info',
    hireInMessage: 'Please insert lease in rent info',
    selectVesselFirst: 'Please select a ship for estimate',
    notMatchSpeedInfo: 'The corresponding speed fuel consumption information is not matched. Please configure it first',
    notMatchDistanceInFO: 'The mileage is not matched to the corresponding port, which can be configured in the corresponding module',
    distanceGetError: 'Failed to obtain port spacing. Please try again later',
    cargoMessage: 'Please add pallet information',
    deadweight: 'Deadweight',
    startPort: 'Start Port',
    palletsStatus: 'Pallets Status',
    loadPort: 'Load Port',
    disPort: 'Discharge Port',
    descriptionMessage: 'Please Enter Description',
    addFromContract: 'Add From Contract',
    importTimeContract: 'Import Time Contract',
    generateTimeContract: 'Generate Time Contract',
    ballastSubsidy: 'Ballast Subsidy',
    sweepFee: 'Sweep Fee',
    isBtb: 'Is btb',
    btbDescription: 'Btb Description',
    tradeType: 'Trade Type',
    cargoClass: 'Cargo Class',
    serialNumber: 'Serial Number',
    chartererNameDetail: 'Charterer Overview',
    contractOverView: 'Contract Overview',
    portInit: 'Port Init',
    totalSoliciteAmount: 'Total Solicite Amount',
    totalSaleAmount: 'Total Sale Amount',
    totalSoliciteCommission: 'Total Solicite Commission',
    totalSaleCommission: 'Total Sale Commission',
    totalCommissionAmount: 'Total Commission Amount',
    transferEstimateDetail: 'Transfer Estimate Detail',
    newSettleTimeLeaseBulkCargo: 'New Settle Time Lease Bulk Cargo',
    newSettleRentBulkCargo: 'New Settle Rent Bulk Cargo',
    newSettleTransferCharter: 'New Settle Transfer Charter',
    addEstimate: 'Add Estimate',
    addSettlement: 'Add Settlement',
    enquiryEstimate: 'Enquiry Estimate',
    amongSulfurDay: 'Among Sulfur Day',
    tceBalance: 'TCE BALANCE',
    companyName: 'Company',
    freightType: 'Freight Type',
    bunkerPriceCheck: 'Oil Price Calculate',
    freightOtherIncome: 'Freight Other Income',
    demurrageCharges: 'Demurrage Charges',
    dispatchCharges: 'Dispatch Charges',
    isOverload: 'Is Overload',
    expectStartTime: 'Expect Start Time',
    backToBackAdd: 'Add Back To Back',
    cargoAmount: 'Cargo Fee',
    totalFreightExpense: 'Total Freight Expense',
    executeVoyageNo: 'Execute Voyage No',
    executeVoyageStatus: 'Execute Voyage Status',
    tradingArea: 'Trading Area',
    //航次预结算
    voyageBusinessAny: 'Voyage Business Analysis',
    voyageAdvanceSettle: 'Voyage Advance Settle',
    voyageAdvanceDetail: 'Voyage Advance Detail',
    estimateIncome: 'Estimate Income',
    budgetIncome: 'Budget Income',
    estimateExpense: 'Estimate Expense',
    budgetExpense: 'Budget Expense',
    estimateTceIncome: 'Estimate TCE Income',
    budgetTceIncome: 'Budget TCE Income',
    estimateDailyTce: 'Estimate Daily TCE',
    budgetDailyTce: 'Budget Daily TCE',
    approvalTime: 'Approval Time',
    version: 'Version',
    voyageEndAudit: 'Vouage End Approval',
    completedVoyageTime: 'Completed Voyage Time',
    completedVoyageFuel: 'Completed Voyage Fuel',
    uncompleteVoyageTime: 'Uncomplete Voyage Time',
    uncompleteVoyageFuel: 'Uncomplete Voyage Fuel',
    timeConsume: 'Time Consume',
    fuelConsume: 'Fuel Consume',
    onPortDay: 'Port Days',
    voyageLanding: 'Voyage Landing',
    voyageSettlement: 'Voyage Settlement',
    voyageSettlementDetail: 'Voyage Settlement Detail',
    //voyageLanding: 'Voyage Landing',
    voyageIncome: 'Voyage Income',
    voyageExpense: 'Voyage Expense',
    voyageBalance: 'Voyage Balance',
    businessDays: 'Business Days',
    businessKind: 'Business Kind',
    removeOffLease: 'Remove Off Lease',
    auditFlag: 'Audit Flag',
    reckoner: 'Reckoner',
    balanceDate: 'Balance Date',
    exportCompare: 'Export Settlement and Calculation Comparison',
    recalculate: 'Recalculate',
    viewContractDetail: 'View Contract Detail',
    viewVoyageTask: 'View Voyage Task',
    historySettlement: 'History Settlement',
    exportVloc: 'Export VLOC Settlement',
    voyageEndApproval: 'Voyage End Approval',
    voyageSpeedInfo: 'Voyage Speed Info',
    cargoQuantity: 'Cargo Quantity',
    workEfficiency: 'Work Efficiency',
    hoursOfTt: 'TT(Hours)',
    advanceSettleInfo: 'The following budget values are based on the voyage calculation of the charterer, and the settlement values are based on the monthly end settlement of the dispatcher。',
    compareSettleInfo: 'The following budget values are based on the voyage calculations of the charterers, while the actual values are based on the voyage settlements of the dispatchers。',
    importvoyageCalculation: 'import voyage calculation',
    setTheMainCalculation: 'Set as the main calculation',
    deleteAssociation: 'delete Association',
    mainCalculation: 'main calculation',
    //航次结算
    voyageInformation: 'Voyage Information',
    settlementIncome: 'Settlement Income',
    settlementCost: 'Settlement Cost',
    settlementTce: 'Settlement Income',
    settlementTceNet: 'Settlement Day Of Tce',
    //other
    endPort: 'End Port',
    portDistances: 'Port Distances',
    lowSulfurDistance: 'Low Sulfur Distance',
    cancelApprove: 'Cancel Approve',
    price: 'Price',
    cargoNum: 'Cargo Num',
    extraCharge: 'Extra Charge',
    businessType: 'Business Type',
    jumpToNew: 'Jump To Newest'
  },
  vloc: {
    addVlocEstimate: 'Add Vloc Estimate',
    freshSelectData: 'Refresh Select Data',
    viewVlocFuel: 'VLOC Fuel Data',
    vlocEstimate: 'VLOC Estimate',
    vlocEstimateDetail: 'VLOC Estimate Detail',
    yearMonth: 'Year Month',
    gDayRent: 'G Of Day Rent',
    operatingDays: 'Operating Days',
    accumulatedOperatingDays: 'Accumulated Operating Days',
    rentFreight: 'Rent/Freight',
    accumulatedRentFreight: 'Accumulated Rent/Freight',
    firstBrokerComm: 'Broker1 Comm',
    firstBrokerCommAmount: 'Broker1 Comm Amount',
    detailCount: 'Vloc Detail Count',
    vlocCreateTime: 'Vloc Create Time',
    vlocModifyTime: 'Vloc Modify Time',
    consumptionQty: 'Acutal Consumption Quantity\n(20th Noon Report)',
    estimateConsumptionQty: 'Estimate Consumption Quantity\n(Noon Report To End)',
    averagePrice: 'Avg Price',
    consumptionAmount: 'Actual Consumption Amount\n(20th Noon Report)',
    estimateAmount: 'Estimate Consumption Amount\n(Noon Report To End)',
    amount: 'Total Consumption Amount'
  },
  tce: {
    tceEstimate: 'POOL Estimate Balance',
    tceEstimateDetail: 'POOL Estimate Balance Detail',
    detailCount: 'POOL Balanace Detail Count',
    tceCreateTime: 'POOL Balance Create Time',
    tceModifyTime: 'POOL Balance Modify Time',
    monthEstiamte: 'This Month Estiamte',
    preMonthEstimate: 'Last Month(Refer)',
    totalOperationDays: 'Total Operation Days',
    lockOperationDays: 'Lock Operation Days',
    lockTce: 'Lock TCE',
    lockTceIncome: 'Lock TCE INCOME',
    unlockOperationDays: 'Unlock Operation Days',
    lockRate: 'Lock Rate（%）',
    lockOrEstimateTce: 'LOCK TCE/\nEst TCE',
    lockOrEstimateDay: 'Lock Operation Days/\nEst Operation Days',
    lockDay: 'Lock Days',
    detailLockTce: 'Lock TCE',
    detailLockTceIncome: 'Lock TCE Income',
    annualRange: 'Annual/Range',
    tceLockDetail: 'TCE Lock Detail',
    tceLockSummary: 'TCE Lock Rate',
    tceEstOther: 'TCE Est Other',
    generateRecalucation: 'Generate/Refresh'
  },
  budget: {
    budgetManage: 'Budget Manage',
    operationalPlan: 'Operational Plan',
    dayNetTce: 'Day Net TCE',
    dayGrossTce: 'Day Gross TCE',
    operationRate: 'Operation Rate',
    grossTceIncome: 'Gorss Tce Income',
    estRetireDate: 'EST Retire Date',
    commissionAmount: 'Commission Amount',
    totalNetIncome: 'Total Net Income',
    totalGrossIncome: 'Total Gross Income'
  }
};